import React from 'react';
import { Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const RequestConfirmationSuccess = () => {
  const intl = useIntl();
  return (
    <Message
      positive
      className="aridhia-request-confirmation-success"
      size="small"
      icon="thumbs up"
      header={intl.formatMessage({ id: 'access.request.complete.title' })}
      content={intl.formatMessage({ id: 'access.request.complete' })}
    />
  );
};

export default RequestConfirmationSuccess;
